
import React from 'react';
import { Navbar } from '@/components/Navbar';
import { Footer } from '@/components/Footer';
import { Pricing as PricingSection } from '@/components/Pricing';
import { useLanguage } from '@/contexts/LanguageContext';

const Pricing = () => {
  const { t } = useLanguage();
  
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      
      <main className="flex-1 container py-8 mt-16">
        <div className="mb-8 text-center">
        </div>
        
        <PricingSection />
      </main>
      
      <Footer />
    </div>
  );
};

export default Pricing;
